import React from "react";
import { Button } from "react-bootstrap";
import Navbar from "../../Components/Navbar";
import { useNavigate } from "react-router-dom";
import BenefitsSc from "./index.sc";
import DownloadICS from "./DownloadIcx";
import OutlookEvent from "./outlookEvent";

function Index() {
  const navigate = useNavigate();

  return (
    <BenefitsSc>
      <div className="button-main" style={{ padding: "10px" }}>
        <Button onClick={() => navigate("holidayCalendar")}>Holiday</Button>
   
        {/* <DownloadICS /> */}

        {/* <OutlookEvent /> */}
      </div>
    </BenefitsSc>
  );
}

export default Index;
